var map = {
	"./tapir-black.png": 156,
	"./tapir-blue.png": 157,
	"./tapir-brown.png": 158,
	"./tapir-green.png": 159,
	"./tapir-grey.png": 160,
	"./tapir-lightblue.png": 161,
	"./tapir-orange.png": 162,
	"./tapir-pink.png": 163,
	"./tapir-red.png": 164,
	"./tapir-white.png": 165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;